import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CustomTranslationsService } from '../translations';

@Pipe({
  name: 'gatewayConnectionMode',
  standalone: true,
})
export class TranslateGatewayConnectionModePipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string): string {
    if (value && this.customTranslationsService.GATEWAY_CONNECTION_MODE[value]) {
      return this.translateService.instant(
        this.customTranslationsService.GATEWAY_CONNECTION_MODE[value] ?? value
      );
    }

    return value;
  }
}
